import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const PrivacyPolicys = async () => {
  try {
    return await getData(`/website/privacypolicy/privacypolicy`);
  } catch (error) {
    console.log(error);
  }
};